"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _SecondaryIconButton = _interopRequireDefault(require("./SecondaryIconButton"));
var _activeMixin = require("./activeMixin");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ActiveIconButtonStyled = (0, _styledComponents["default"])(_SecondaryIconButton["default"]).withConfig({
  displayName: "ActiveIconButton__ActiveIconButtonStyled",
  componentId: "sc-moikfw-0"
})(["", ""], function (props) {
  return (0, _activeMixin.activeMixin)(props);
});
var ActiveIconButton = function ActiveIconButton(props) {
  return /*#__PURE__*/_react["default"].createElement(ActiveIconButtonStyled, props);
};
var _default = ActiveIconButton;
exports["default"] = _default;